export default "__VITE_ASSET__DuuQsJdB__"